export default () => ({
  radioGroupHeader: ({ fontSize }) => ({
    color: '#00000099',
    fontSize: fontSize ? fontSize : 20,
    letterSpacing: 0,
    fontWeight: 300,
  }),
  radioLabel: ({ fontSize }) => ({
    color: '#000000DE',
    fontSize: fontSize ? fontSize : 18,
    letterSpacing: 0,
    fontWeight: 600,
  }),
  selectLabel: { color: '#000', fontWeight: 300, letterSpacing: 0 },
  checkboxLabel: {
    fontFamily: 'Roboto',
    fontSize: 16,
    letterSpacing: 0,
    lineHeight: 0.25,
    color: '#707070',
  },
});
